import Axios from 'axios'
import { processQueryForSearch } from '../utils/azure-search-utils'
import strings from '../strings'
import { getCookie } from '../utils/auth-utils'

const exam = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL
    return AxiosInstance
  },
  search(query) {
    let instance = this.axios().create({
      baseURL: process.env.AZURE_SEARCH_BASE_URL,
      timeout: 5000,
      headers: {
        'api-key': process.env.AZURE_SEARCH_API_KEY,
        'Content-Type': 'application/json',
      },
    })

    return instance.get('/indexes/exams2/docs', {
      params: {
        'api-version': process.env.AZURE_SEARCH_API_VERSION,
        search: processQueryForSearch(query),
        $top: 50,
        $orderby: 'search.score() desc,code asc,name asc',
        queryType: 'full',
      },
    })
  },
  searchAlternative(query) {
    return this.axios().get('/exam/search/' + query)
  },
  getMostSentExams() {
    return this.axios().get('/exam/most-sent')
  },
  getExamDetailsById(id) {
    const instance = Axios.create({
      baseURL: process.env.BACKEND_URL,
      headers: {
        Authorization: strings.headers.bearerAuthentication + getCookie('token_aol'),
      },
    })

    return instance.get('/exam/' + id)
  },
  getExamDetailsByMnemonic(mnemonic) {
    const instance = Axios.create({
      baseURL: process.env.BACKEND_URL,
      headers: {
        Authorization: strings.headers.bearerAuthentication + getCookie('token_aol'),
      },
    })

    return instance.get('/exam/mnemonic/' + mnemonic)
  },
  getAvailableExamsForVoucher() {
    return this.axios().get('/exam/voucher-exams')
  },
  includeExam(data) {
    return this.axios().put('/exam/inclusion', data, {})
  },
  deleteExam({ idOsAlvaro, code, codeSample }) {
    return this.axios().delete('/exam/delete', {
      data: { idOsAlvaro, code, codeSample },
    })
  },
  updateCollectionDate({ idOsAlvaro, dataColeta }) {
    return this.axios().put('/exam/observation', {
      idOsAlvaro,
      dataColeta,
    })
  },
  getExams(filter) {
    /** @todo Replace the mock with the real API. */
    // return this.axios().get('', {
    //   params: filter
    // })

    return new Promise(resolve => setTimeout(() => resolve({
      data: [
        {
          "id": "68bed01787e1fa2934330d61",
          "partition": "ALVARO|1789",
          "brand": "ALVARO",
          "idLaboratory": "1789",
          "currentStatus": "AMOSTRA_OBTIDA",
          "currentStatusDate": "2025-09-08T09:53:26",
          "idOrder": "327706982",
          "idOrderMotion": "3569",
          "codeExamMotion": "3569",
          "codeExamBrand": "TSH",
          "codeSample": "703634283985",
          "events": [
            {
              "date": "2025-09-08T09:46:15",
              "status": "CADASTRADO"
            },
            {
              "date": "2025-09-08T09:53:26",
              "status": "AMOSTRA_OBTIDA"
            }
          ],
          "idDestination": null,
          "destination": "Alpha C",
          "lotId": "None",
          "patientName": "LUIZ BONFANTE",
          "latitude": null,
          "longitude": null,
          "dueDate": "2025-10-08T09:53:26",
          "releaseDate": null,
          "isFinished": null,
          "materialId": "543",
          "material": "soro",
          "isDelayed": false,
          "rescheduledDate": null,
          "originalDueDate": null,
          "orderCreatedDate": "2025-09-08T12:46:15.315+0000",
          "IdOsLis": "",
          "currentStatusDescription": "Aguardando retirada"
        },
        {
          "id": "68bed01887e1fa2934330d62",
          "partition": "ALVARO|1789",
          "brand": "ALVARO",
          "idLaboratory": "1789",
          "currentStatus": "AMOSTRA_OBTIDA",
          "currentStatusDate": "2025-09-08T09:53:28",
          "idOrder": "327706982",
          "idOrderMotion": "1086",
          "codeExamMotion": "1086",
          "codeExamBrand": "CREA1",
          "codeSample": "703634283992",
          "events": [
            {
              "date": "2025-09-08T09:46:16",
              "status": "CADASTRADO"
            },
            {
              "date": "2025-09-08T09:53:28",
              "status": "AMOSTRA_OBTIDA"
            },
            {
              "date": "2025-09-09T12:25:12",
              "status": "EM_TRANSITO"
            }
          ],
          "idDestination": null,
          "destination": "Alpha C",
          "lotId": "None",
          "patientName": "LUIZ BONFANTE",
          "latitude": null,
          "longitude": null,
          "dueDate": "2025-10-08T09:53:28",
          "releaseDate": null,
          "isFinished": null,
          "materialId": "754",
          "material": "urina amostra isolada",
          "isDelayed": false,
          "rescheduledDate": null,
          "originalDueDate": null,
          "orderCreatedDate": "2025-09-08T12:46:15.315+0000",
          "IdOsLis": "",
          "currentStatusDescription": "Aguardando retirada"
        },
        {
          "id": "68bed01887e1fa2934330d63",
          "partition": "ALVARO|1789",
          "brand": "ALVARO",
          "idLaboratory": "1789",
          "currentStatus": "CADASTRADO",
          "currentStatusDate": "2025-09-08T09:46:16",
          "idOrder": "327706982",
          "idOrderMotion": "38341",
          "codeExamMotion": "38341",
          "codeExamBrand": "ANAT4",
          "codeSample": "044736680938",
          "events": [
            {
              "date": "2025-09-08T09:46:16",
              "status": "CADASTRADO"
            }
          ],
          "idDestination": null,
          "destination": "Patologia Jurua",
          "lotId": "None",
          "patientName": "LUIZ BONFANTE",
          "latitude": null,
          "longitude": null,
          "dueDate": "2025-10-08T09:46:16",
          "releaseDate": null,
          "isFinished": null,
          "materialId": "1194",
          "material": "Anátomo Patológico",
          "isDelayed": false,
          "rescheduledDate": null,
          "originalDueDate": null,
          "orderCreatedDate": "2025-09-08T12:46:15.315+0000",
          "IdOsLis": "",
          "currentStatusDescription": "Cadastro realizado"
        },
        {
          "id": "68bed1c787e1fa2934330d65",
          "partition": "ALVARO|1789",
          "brand": "ALVARO",
          "idLaboratory": "1789",
          "currentStatus": "AMOSTRA_OBTIDA",
          "currentStatusDate": "2025-09-08T09:53:27",
          "idOrder": "327706982",
          "idOrderMotion": "926959408771",
          "codeExamMotion": "38341",
          "codeExamBrand": "ANAT4",
          "codeSample": "504453202801",
          "events": [
            {
              "date": "2025-09-08T09:53:27",
              "status": "AMOSTRA_OBTIDA"
            }
          ],
          "idDestination": null,
          "destination": null,
          "lotId": null,
          "patientName": "LUIZ BONFANTE",
          "latitude": null,
          "longitude": null,
          "dueDate": "2025-10-08T09:53:27",
          "releaseDate": null,
          "isFinished": null,
          "materialId": null,
          "material": null,
          "isDelayed": false,
          "rescheduledDate": null,
          "originalDueDate": null,
          "orderCreatedDate": "2025-09-08T12:46:15.315+0000",
          "IdOsLis": "",
          "currentStatusDescription": "Aguardando retirada"
        },
        {
          "id": "68bee98887e1fa2934330d67",
          "partition": "ALVARO|1789",
          "brand": "ALVARO",
          "idLaboratory": "1789",
          "currentStatus": "AMOSTRA_OBTIDA",
          "currentStatusDate": "2025-09-08T11:41:40",
          "idOrder": "327706983",
          "idOrderMotion": "3569",
          "codeExamMotion": "3569",
          "codeExamBrand": "TSH",
          "codeSample": "703634284012",
          "events": [
            {
              "date": "2025-09-08T11:34:48",
              "status": "CADASTRADO"
            },
            {
              "date": "2025-09-08T11:41:40",
              "status": "AMOSTRA_OBTIDA"
            }
          ],
          "idDestination": null,
          "destination": "Alpha C",
          "lotId": "None",
          "patientName": "TESTE1",
          "latitude": null,
          "longitude": null,
          "dueDate": "2025-10-08T11:41:40",
          "releaseDate": null,
          "isFinished": null,
          "materialId": "543",
          "material": "soro",
          "isDelayed": false,
          "rescheduledDate": null,
          "originalDueDate": null,
          "orderCreatedDate": "2025-09-08T14:34:48.517+0000",
          "IdOsLis": "",
          "currentStatusDescription": "Aguardando retirada"
        },
        {
          "id": "68beea2187e1fa2934330d68",
          "partition": "ALVARO|1789",
          "brand": "ALVARO",
          "idLaboratory": "1789",
          "currentStatus": "AMOSTRA_OBTIDA",
          "currentStatusDate": "2025-09-08T11:45:42",
          "idOrder": "327706984",
          "idOrderMotion": "3569",
          "codeExamMotion": "3569",
          "codeExamBrand": "TSH",
          "codeSample": "703634284029",
          "events": [
            {
              "date": "2025-09-08T11:37:21",
              "status": "CADASTRADO"
            },
            {
              "date": "2025-09-08T11:45:42",
              "status": "AMOSTRA_OBTIDA"
            }
          ],
          "idDestination": null,
          "destination": "Alpha C",
          "lotId": "None",
          "patientName": "TESTE1",
          "latitude": null,
          "longitude": null,
          "dueDate": "2025-10-08T11:45:42",
          "releaseDate": null,
          "isFinished": null,
          "materialId": "543",
          "material": "soro",
          "isDelayed": false,
          "rescheduledDate": null,
          "originalDueDate": null,
          "orderCreatedDate": "2025-09-08T14:37:21.904+0000",
          "IdOsLis": "",
          "currentStatusDescription": "Aguardando retirada"
        },
        {
          "id": "68beebb487e1fa2934330d69",
          "partition": "ALVARO|1789",
          "brand": "ALVARO",
          "idLaboratory": "1789",
          "currentStatus": "AMOSTRA_OBTIDA",
          "currentStatusDate": "2025-09-08T11:49:31",
          "idOrder": "327706985",
          "idOrderMotion": "3569",
          "codeExamMotion": "3569",
          "codeExamBrand": "TSH",
          "codeSample": "703634284036",
          "events": [
            {
              "date": "2025-09-08T11:44:04",
              "status": "CADASTRADO"
            },
            {
              "date": "2025-09-08T11:49:31",
              "status": "AMOSTRA_OBTIDA"
            }
          ],
          "idDestination": null,
          "destination": "Alpha C",
          "lotId": "LT0A00048363",
          "patientName": "TESTE1",
          "latitude": null,
          "longitude": null,
          "dueDate": "2025-10-08T11:49:31",
          "releaseDate": null,
          "isFinished": null,
          "materialId": "543",
          "material": "soro",
          "isDelayed": false,
          "rescheduledDate": null,
          "originalDueDate": null,
          "orderCreatedDate": "2025-09-08T14:44:04.379+0000",
          "IdOsLis": "",
          "currentStatusDescription": "Aguardando retirada"
        },
        {
          "id": "68bf1dc787e1fa2934330d85",
          "partition": "ALVARO|1789",
          "brand": "ALVARO",
          "idLaboratory": "1789",
          "currentStatus": "AMOSTRA_OBTIDA",
          "currentStatusDate": "2025-09-08T15:25:37",
          "idOrder": "327706995",
          "idOrderMotion": "3569",
          "codeExamMotion": "3569",
          "codeExamBrand": "TSH",
          "codeSample": "703634284050",
          "events": [
            {
              "date": "2025-09-08T15:17:43",
              "status": "CADASTRADO"
            },
            {
              "date": "2025-09-08T15:25:37",
              "status": "AMOSTRA_OBTIDA"
            }
          ],
          "idDestination": null,
          "destination": "Alpha C",
          "lotId": "None",
          "patientName": "TESTE1",
          "latitude": null,
          "longitude": null,
          "dueDate": "2025-10-08T15:25:37",
          "releaseDate": null,
          "isFinished": null,
          "materialId": "543",
          "material": "soro",
          "isDelayed": false,
          "rescheduledDate": null,
          "originalDueDate": null,
          "orderCreatedDate": "2025-09-08T18:17:43.486+0000",
          "IdOsLis": "",
          "currentStatusDescription": "Aguardando retirada"
        },
        {
          "id": "68c170059d5032406791957d",
          "partition": "ALVARO|1789",
          "brand": "ALVARO",
          "idLaboratory": "1789",
          "currentStatus": "AMOSTRA_OBTIDA",
          "currentStatusDate": "2025-09-10T09:41:26",
          "idOrder": "327707038",
          "idOrderMotion": "3569",
          "codeExamMotion": "3569",
          "codeExamBrand": "TSH",
          "codeSample": "703634284265",
          "events": [
            {
              "date": "2025-09-10T09:33:09",
              "status": "CADASTRADO"
            },
            {
              "date": "2025-09-10T09:41:26",
              "status": "AMOSTRA_OBTIDA"
            }
          ],
          "idDestination": null,
          "destination": "Alpha C",
          "lotId": "LT0A00048389",
          "patientName": "PACIENTE_TEST",
          "latitude": null,
          "longitude": null,
          "dueDate": "2025-10-10T09:41:26",
          "releaseDate": null,
          "isFinished": null,
          "materialId": "543",
          "material": "soro",
          "isDelayed": false,
          "rescheduledDate": null,
          "originalDueDate": null,
          "orderCreatedDate": "2025-09-10T12:33:09.833+0000",
          "IdOsLis": "",
          "currentStatusDescription": "Aguardando retirada"
        },
        {
          "id": "68c1a8209d5032406791959c",
          "partition": "ALVARO|1789",
          "brand": "ALVARO",
          "idLaboratory": "1789",
          "currentStatus": "AMOSTRA_OBTIDA",
          "currentStatusDate": "2025-09-10T13:41:47",
          "idOrder": "327707050",
          "idOrderMotion": "3569",
          "codeExamMotion": "3569",
          "codeExamBrand": "TSH",
          "codeSample": "703634284395",
          "events": [
            {
              "date": "2025-09-10T13:32:32",
              "status": "CADASTRADO"
            },
            {
              "date": "2025-09-10T13:41:47",
              "status": "AMOSTRA_OBTIDA"
            }
          ],
          "idDestination": null,
          "destination": "Alpha C",
          "lotId": "LT0A00048389",
          "patientName": "PACIENTE_TEST",
          "latitude": null,
          "longitude": null,
          "dueDate": "2025-10-10T13:41:47",
          "releaseDate": null,
          "isFinished": null,
          "materialId": "543",
          "material": "soro",
          "isDelayed": false,
          "rescheduledDate": null,
          "originalDueDate": null,
          "orderCreatedDate": "2025-09-10T16:32:32.181+0000",
          "IdOsLis": "",
          "currentStatusDescription": "Aguardando retirada"
        },
        {
          "id": "68c1b9d79d503240679195a3",
          "partition": "ALVARO|1789",
          "brand": "ALVARO",
          "idLaboratory": "1789",
          "currentStatus": "AMOSTRA_OBTIDA",
          "currentStatusDate": "2025-09-10T14:53:48",
          "idOrder": "327707055",
          "idOrderMotion": "3569",
          "codeExamMotion": "3569",
          "codeExamBrand": "TSH",
          "codeSample": "703634284418",
          "events": [
            {
              "date": "2025-09-10T14:48:07",
              "status": "CADASTRADO"
            },
            {
              "date": "2025-09-10T14:53:48",
              "status": "AMOSTRA_OBTIDA"
            }
          ],
          "idDestination": null,
          "destination": "Alpha C",
          "lotId": "LT0A00048389",
          "patientName": "PACIENTE_TEST",
          "latitude": null,
          "longitude": null,
          "dueDate": "2025-10-10T14:53:48",
          "releaseDate": null,
          "isFinished": null,
          "materialId": "543",
          "material": "soro",
          "isDelayed": false,
          "rescheduledDate": null,
          "originalDueDate": null,
          "orderCreatedDate": "2025-09-10T17:48:08.099+0000",
          "IdOsLis": "",
          "currentStatusDescription": "Aguardando retirada"
        },
        {
          "id": "68c1ba3f9d503240679195a5",
          "partition": "ALVARO|1789",
          "brand": "ALVARO",
          "idLaboratory": "1789",
          "currentStatus": "AMOSTRA_OBTIDA",
          "currentStatusDate": "2025-09-10T14:57:33",
          "idOrder": "327707057",
          "idOrderMotion": "3569",
          "codeExamMotion": "3569",
          "codeExamBrand": "TSH",
          "codeSample": "703634284425",
          "events": [
            {
              "date": "2025-09-10T14:49:51",
              "status": "CADASTRADO"
            },
            {
              "date": "2025-09-10T14:57:33",
              "status": "AMOSTRA_OBTIDA"
            }
          ],
          "idDestination": null,
          "destination": "Alpha C",
          "lotId": "LT0A00048389",
          "patientName": "PACIENTE_TEST",
          "latitude": null,
          "longitude": null,
          "dueDate": "2025-10-10T14:57:33",
          "releaseDate": null,
          "isFinished": null,
          "materialId": "543",
          "material": "soro",
          "isDelayed": false,
          "rescheduledDate": null,
          "originalDueDate": null,
          "orderCreatedDate": "2025-09-10T17:49:51.588+0000",
          "IdOsLis": "",
          "currentStatusDescription": "Aguardando retirada"
        },
      ]
    }), Math.random() * 1e3))
  },
  fetchLogisticBatchesHeader(filter) {
    return new Promise(resolve => setTimeout(() => resolve({
      data: {
        AGUARDANDO_RETIRADA: 0,
        EM_TRANSITO: 0,
        TRIAGEM: 0,
        EM_EXECUCAO: 0,
        EM_LIBERACAO: 0,
        LAUDO_LIBERADO: 0,
        COM_PENDENCIA: 0,
        SOLICITADA_RECOLETA: 0,
        RECOLETADO: 0,
        REMARCADO: 0,
        LAUDO_VISUALIZADO: 0,
        EXAME_CANCELADO: 0,
        FINALIZADO: 0,
        AMOSTRA_DESCARTADA: 0,
        RECONVOCADO: 0,
        AMOSTRA_OBTIDA: 0,
        NAO_LOTEADA_FISICAMENTE: 0,
        CANCELADO: 0,
        NAO_RASTREADO: 0,
        RETIRADA_EXPIRADA: 0,
        NAO_RECEBIDA: 0,
        EM_TRANSITO_ENTRE_NTO: 0,
        CADASTRADO: 0,
        CANCELADO_CLIENTE: 0,
        NAO_ENVIADA: 0,
        PENDENCIA_CRIADA: 0,
        PENDENCIA_RESPONDIDA: 0,
        EMITIDO: 0,
        ENTREGUE_AO_NTO: 0,
        ADIANTADO: 0,
        ATRASADO: 0,
      }
    }), Math.random() * 1e3))
  },
  fetchLogisticSamplesHeader() {
    return new Promise(resolve => setTimeout(() => resolve({
      data: {
        AGUARDANDO_RETIRADA: 0,
        EM_TRANSITO: 0,
        TRIAGEM: 0,
        EM_EXECUCAO: 0,
        EM_LIBERACAO: 0,
        LAUDO_LIBERADO: 0,
        COM_PENDENCIA: 0,
        SOLICITADA_RECOLETA: 0,
        RECOLETADO: 0,
        REMARCADO: 0,
        LAUDO_VISUALIZADO: 0,
        EXAME_CANCELADO: 0,
        FINALIZADO: 0,
        AMOSTRA_DESCARTADA: 0,
        RECONVOCADO: 0,
        AMOSTRA_OBTIDA: 0,
        NAO_LOTEADA_FISICAMENTE: 0,
        CANCELADO: 0,
        NAO_RASTREADO: 0,
        RETIRADA_EXPIRADA: 0,
        NAO_RECEBIDA: 0,
        EM_TRANSITO_ENTRE_NTO: 0,
        CADASTRADO: 0,
        CANCELADO_CLIENTE: 0,
        NAO_ENVIADA: 0,
        PENDENCIA_CRIADA: 0,
        PENDENCIA_RESPONDIDA: 0,
        EMITIDO: 0,
        ENTREGUE_AO_NTO: 0,
        ADIANTADO: 0,
        ATRASADO: 0,
      }
    }), Math.random() * 1e3))
  },
  fetchLogisticSamplesHeader() {
    return new Promise(resolve => setTimeout(() => resolve({
      data: {
        AGUARDANDO_RETIRADA: 0,
        EM_TRANSITO: 0,
        TRIAGEM: 0,
        EM_EXECUCAO: 0,
        EM_LIBERACAO: 0,
        LAUDO_LIBERADO: 0,
        COM_PENDENCIA: 0,
        SOLICITADA_RECOLETA: 0,
        RECOLETADO: 0,
        REMARCADO: 0,
        LAUDO_VISUALIZADO: 0,
        EXAME_CANCELADO: 0,
        FINALIZADO: 0,
        AMOSTRA_DESCARTADA: 0,
        RECONVOCADO: 0,
        AMOSTRA_OBTIDA: 0,
        NAO_LOTEADA_FISICAMENTE: 0,
        CANCELADO: 0,
        NAO_RASTREADO: 0,
        RETIRADA_EXPIRADA: 0,
        NAO_RECEBIDA: 0,
        EM_TRANSITO_ENTRE_NTO: 0,
        CADASTRADO: 0,
        CANCELADO_CLIENTE: 0,
        NAO_ENVIADA: 0,
        PENDENCIA_CRIADA: 0,
        PENDENCIA_RESPONDIDA: 0,
        EMITIDO: 0,
      }
    }), Math.random() * 1e3))
  }
}

export default exam
